module.exports = __webpack_public_path__ + "static/video-call-web-app-cover-e3d9b85fea6a811ea3f8dfa82e0d1a48.png";